<template>

    <div class="w-100 h-100 border-0">

        <b-row class="mb-0 pl-3">

            <b-col cols="9">

                <!-- CURRENT User block -->
                <div class="bg-white p-2 border border secondary mb-1" v-if="currentSelectedStaffUserAccounts && currentSelectedStaffUserAccounts.find(o => o.userAccountId === currentUserAccountId)">
                    <b-row class="align-middle" small>
                        <!--<b-col cols="1" v-if="roundRobinMode"></b-col>-->
                        <b-col :cols="roundRobinMode ? '3' : '2'" class="text-secondary">Current user</b-col>
                        <b-col :cols="roundRobinMode ? '3' : '3'">{{ getStaffName(currentUserAccountId) }}</b-col>

                        <b-col>
                            <b-button-group size="sm">
                                <b-button-group size="sm">
                                    <!-- the first getRoles gets all roles of a user - not the selected roles -->
                                    <b-button v-for="(role, idx) in getRoles(currentUserAccountId)" :key="idx"
                                              v-b-tooltip.hover :title="!canUnselectRole(currentUserAccount, role.roleId) ? 'REQUIRED: ' + role.roleDisplayName : role.roleDisplayName"
                                              v-bind:class="[currentUserAccount.selectedRoles && currentUserAccount.selectedRoles.includes(role.roleId) ? 'bg-success' : '']"
                                              style="background-color: #ccc; width:50px;"
                                              @click="selectRole($event,currentUserAccountId,role.roleId)">
                                        {{ getRoleAbbreviation(role.roleDisplayName) }}
                                    </b-button>
                                </b-button-group>
                            </b-button-group>
                        </b-col>
                    </b-row>
                </div>

                <b-alert variant="warning" :show="roleSelectionIncomplete" dismissible class="mb-1">
                    WARNING: Please make sure that every newly ADDED and every EXISTING assignment has at least one role selected.
                </b-alert>

                <b-alert variant="warning" :show="nullMinuteAssignmentPresent && isDelayedAssignment" dismissible class="mb-1">
                    WARNING: Allocation mode 'Assigned Audio Length' requires minutes entered for every user. Please supply 1 or more minutes in the input fields below.
                </b-alert>

                <b-alert variant="warning" :show="zeroMinuteAssignmentsPresent && isDelayedAssignment" class="mb-1 pb-0">
                    WARNING: There are still users with 0 minutes assigned present. Please do either of the following:
                    <ul class="pb-0">
                        <li>increase the minutes for relevant users</li>
                        <li>clear the input field for relevant users</li>
                        <li>or remove the user from your selection</li>
                    </ul>
                </b-alert>

                <b-alert variant="info" :show="showProtectedRoleAlert" class="mb-1">
                    WARNING: This role is required. It can not be removed from the user/assignment.
                </b-alert>

                <b-alert variant="warning" :show="!newlySelectedStaffUserAccounts" class="mb-1">
                    No new staff selected.
                </b-alert>

                <b-row v-if="isDelayedAssignment">
                    <b-col cols="1"></b-col>
                    <b-col cols="1" class="text-center">Mins</b-col>
                    <b-col></b-col>
                    <b-col></b-col>
                </b-row>

                <!-- EXISTING and newly ADDED section -->
                <div v-if="currentSelectedStaffUserAccounts" class="bg-white p-2 border mb-1">
                    <!-- ROUND ROBIN section -->
                    <draggable class="draggable-list" v-model="currentSelectedStaffUserAccounts" group="my-group" v-if="roundRobinMode">
                        <template v-for="(userAccount,index1) in currentSelectedStaffUserAccounts">
                            <b-row class="mb-1" small
                                   :key="userAccount.userAccountId"
                                   :id="userAccount.userAccountId"
                                   @mouseover="rowHovered(userAccount.userAccountId)"
                                   @mouseleave="rowUnHovered(userAccount.userAccountId)"
                                   v-if="userAccount.userAccountId != currentUserAccountId">
                                <b-col cols="1"><i class="fas fa-grip-lines"></i></b-col>

                                <b-col cols="1" v-if="newlySelectedStaffUserAccounts && newlySelectedStaffUserAccounts.find(o => o.userAccountId === userAccount.userAccountId)" class="text-success">Adding</b-col>
                                <b-col cols="1" v-else class="text-primary">Existing</b-col>

                                <b-col cols="1" class="text-center-middle" v-if="isDelayedAssignment">

                                    <b-input v-if="index1==0" autofocus @focus="highlightText"
                                             :disabled="!userAccount.canChangeAssignedMinutes || !userHasRolesWithAudioMinutes(userAccount.userAccountId)"
                                             id="firstAudioMinutesInput" style="height:24px;" maxlength="4"
                                             @keydown.native="validatePositiveInteger" v-model="userAccount.audioMinutes" size="sm" class="text-right" />
                                    <b-input v-else style="height:24px;" maxlength="4"
                                             :disabled="!userAccount.canChangeAssignedMinutes || !userHasRolesWithAudioMinutes(userAccount.userAccountId)"
                                             @keydown.native="validatePositiveInteger" v-model="userAccount.audioMinutes" size="sm" class="text-right" />
                                </b-col>

                                <b-col cols="3">{{ getStaffName(userAccount.userAccountId) }}</b-col>

                                <b-col>
                                    <b-button-group size="sm">

                                        <b-input-group-prepend v-if="userAccount.canUnassign">
                                            <b-button v-on:click="removeUserFromAssignment(userAccount.userAccountId)" v-b-tooltip.hover.topleft title="Remove user" size="sm" variant="danger"><i class="fas fa-times"></i></b-button>
                                        </b-input-group-prepend>

                                        <b-button-group size="sm">
                                            <!-- the first getRoles gets all roles of a user - not the selected roles -->
                                            <b-button v-for="(role, idx) in getRoles(userAccount.userAccountId)" :key="idx"
                                                      v-b-tooltip.hover :title="!canUnselectRole(userAccount, role.roleId) ? 'REQUIRED: ' + role.roleDisplayName : role.roleDisplayName"
                                                      v-bind:class="[userAccount.selectedRoles && userAccount.selectedRoles.includes(role.roleId) ? 'bg-success' : '',
                                                                    !canUnselectRole(userAccount, role.roleId) ? '' : '']"
                                                      style="background-color: #ccc; width:50px;"
                                                      @click="selectRole($event,userAccount.userAccountId,role.roleId)">
                                                {{ getRoleAbbreviation(role.roleDisplayName) }}
                                            </b-button>
                                        </b-button-group>
                                    </b-button-group>
                                </b-col>
                                <b-col cols="2" v-if="userHasRolesWithRoundRobinPriority(userAccount.userAccountId)">
                                    Turn sequence: {{ roundRobinPriority(index1) }}
                                </b-col>

                            </b-row>
                        </template>
                    </draggable>

                    <!-- non ROUND ROBIN section -->
                    <template v-for="(userAccount,index2) in currentSelectedStaffUserAccounts" v-else>

                        <b-row class="mb-1" small
                               :key="userAccount.userAccountId"
                               :id="userAccount.userAccountId"
                               v-if="userAccount.userAccountId != currentUserAccountId">
                            <b-col cols="1" v-if="newlySelectedStaffUserAccounts && newlySelectedStaffUserAccounts.find(o => o.userAccountId === userAccount.userAccountId)" class="text-success">Adding</b-col>
                            <b-col cols="1" v-else class="text-primary">Existing</b-col>

                            <b-col cols="1" class="p-0" v-if="isDelayedAssignment">

                                <b-input-group class="w-100">

                                    <b-input v-if="index2==0"
                                             :disabled="!userAccount.canChangeAssignedMinutes || !userHasRolesWithAudioMinutes(userAccount.userAccountId)"
                                             autofocus @focus="highlightText" id="firstAudioMinutesInput" style="height:24px;" maxlength="4" @keydown.native="validatePositiveInteger" v-model="userAccount.audioMinutes" size="sm" class=" text-right" />
                                    <b-input v-else style="height:24px;" maxlength="4"
                                             :disabled="!userAccount.canChangeAssignedMinutes || !userHasRolesWithAudioMinutes(userAccount.userAccountId)"
                                             @keydown.native="validatePositiveInteger" v-model="userAccount.audioMinutes" size="sm" class=" text-right" />
                                </b-input-group>

                            </b-col>

                            <b-col cols="3">{{ getStaffName(userAccount.userAccountId) }}</b-col>

                            <!--the button business-->
                            <b-col cols="6">
                                <b-button-group size="sm">

                                    <b-input-group-prepend v-if="userAccount.canUnassign">
                                        <b-button v-on:click="removeUserFromAssignment(userAccount.userAccountId)" v-b-tooltip.hover.topleft title="Remove user" size="sm" variant="danger"><i class="fas fa-times"></i></b-button>
                                    </b-input-group-prepend>


                                    <!-- the first getRoles gets all roles of a user - not the selected roles -->
                                    <b-button v-for="(role, idx) in getRoles(userAccount.userAccountId)" :key="idx"
                                              v-b-tooltip.hover :title="!canUnselectRole(userAccount, role.roleId) ? 'REQUIRED: ' + role.roleDisplayName : role.roleDisplayName"
                                              v-bind:class="[userAccount.selectedRoles && userAccount.selectedRoles.includes(role.roleId) ? 'bg-success' : '']"
                                              style="background-color: #ccc; width:50px;"
                                              @click="selectRole($event,userAccount.userAccountId,role.roleId)">
                                        {{ getRoleAbbreviation(role.roleDisplayName) }}
                                    </b-button>
                                </b-button-group>
                            </b-col>

                        </b-row>
                    </template>
                </div>

                <!-- REMOVED staff section-->
                <div v-if="newlyUnselectedStaffUserAccounts" class="bg-white p-2 border border secondary">
                    <b-row class="mb-1" small v-for="(userAccount,index) in newlyUnselectedStaffUserAccounts" v-bind:key="index">
                        <b-col cols="1" v-if="roundRobinMode"></b-col>
                        <b-col :cols="roundRobinMode ? '1' : '1'" class="text-danger">Removing</b-col>

                        <b-col cols="1" class="text-center-middle" v-if="isDelayedAssignment">
                            <!-- josef, ask Helmut -->
                            <b-input v-if="index==0" autofocus @focus="highlightText" :disabled="true" id="firstAudioMinutesInput" style="height:24px;" maxlength="4" @keydown.native="validatePositiveInteger" v-model="userAccount.audioMinutes" size="sm" class="text-right" />
                            <b-input v-else style="height:24px;" maxlength="4" :disabled="true" @keydown.native="validatePositiveInteger" v-model="userAccount.audioMinutes" size="sm" class="text-right" />
                        </b-col>

                        <b-col cols="3">{{ getStaffName(userAccount.userAccountId) }}</b-col>
                        <b-col>

                            <b-button-group size="sm">
                                <!-- the first getRoles gets all roles of a user - not the selected roles -->
                                <b-button v-for="(role, idx) in getRoles(userAccount.userAccountId)" :key="idx"
                                          v-b-tooltip.hover :title="role.roleDisplayName"
                                          v-bind:class="userAccount.selectedRoles && userAccount.selectedRoles.includes(role.roleId) ? 'bg-success' : ''"
                                          style="background-color: #ccc; width:50px;"
                                          :disabled="true">

                                    {{ getRoleAbbreviation(role.roleDisplayName) }}
                                </b-button>
                            </b-button-group>
                        </b-col>
                    </b-row>
                </div>
            </b-col>
            <!--end assignment panel-->
            <!--Message panel-->
            <b-col cols="3" class="pr-4 pt-0 mt-0">
                <b-row cols="12">
                    <b-col cols="12" v-if="isDelayedAssignment">
                        <b-table-simple small class="border-0">
                            <b-tbody>
                                <b-tr class="font-weight-bold">
                                    <b-td class="border-0">Total Audio minutes: </b-td><b-td class="float-right border-0">{{ totalAudioMinutes }}</b-td>
                                </b-tr>
                               
                                <b-tr class="text-primary">
                                    <b-td class="border-0">- Total currently assigned minutes:</b-td><b-td class="float-right border-0">{{ totalCurrentlyAssignedAudioMinutes }}</b-td>
                                </b-tr>

                                <b-tr class="text-success">
                                    <b-td class="border-0">- Total newly assigned minutes:</b-td><b-td class="float-right border-0">{{ totalAddedAudioMinutes }}</b-td>
                                </b-tr>

                                <b-tr class="text-danger">
                                    <b-td class="border-0">+ Total newly removed minutes:</b-td><b-td class="float-right border-0">{{ totalRemovedAudioMinutes }}</b-td>
                                </b-tr>
                                <b-tr class="font-weight-bold">
                                    <b-td>Remaining minutes to be assigned:</b-td><b-td class="float-right">{{ newRemainingMinutesValue }}</b-td>
                                </b-tr>
                            </b-tbody>
                        </b-table-simple>
                    </b-col>
                </b-row>

                <b-row cols="12" v-if="newlySelectedStaffUserAccounts">
                    <b-col>
                        <b-form-textarea v-model="comment"
                                         placeholder="Optional message to staff"
                                         rows="5"
                                         max-rows="6"></b-form-textarea>
                    </b-col>
                </b-row>
                <b-row cols="12" class="mb-3" v-if="newlySelectedStaffUserAccounts">
                    <b-col>

                        <p class="mb-0 mt-2">Response Time:</p>
                        <b-form-select v-model="responseTime" size="sm" :options="responseTimeOptions" class="" />

                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <b-button @click="$emit('hideConfirmationPanel')" variant="secondary" class="w-100">Back</b-button>
                    </b-col>
                    <b-col>
                        <b-button @click="assignSelectedStaff" 
                                  :variant="zeroMinuteAssignmentsPresent || nullMinuteAssignmentPresent || roleSelectionIncomplete || showProtectedRoleAlert ? 'secondary' : 'success'" class="w-100">Update</b-button>
                    </b-col>
                </b-row>
            </b-col>

        </b-row>

        <div class="d-flex justify-content-center">
            <b-spinner variant="secondary" label="Saving..." v-if="showSpinner"></b-spinner>
        </div>
    </div>
    <!--end confirmation panel-->
</template>

<script>
    import Vue from 'vue';
    import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
    import ErrorsMixin from '../../mixins/ErrorsMixin';
    import draggable from "vuedraggable";
    import axios from 'axios';

    Vue.use(BootstrapVue);
    Vue.use(BootstrapVueIcons);

    export default {
        name: 'AssignmentConfirmationPanel',
        mixins: [ ErrorsMixin ],
        components: { draggable },
        model: {
            event: 'change',
            prop: 'active',
        },
        props: {
            workItemId: {
                type: String,
                required: false,
                default: null
            },

            totalAudioMinutes: {
                type: Number,
                default: 0
            },
          
            roundRobinMode: {
                type: Boolean,
                default: false 
            },
            newlySelectedStaffUserAccounts: {
                type: Array,
                default: null
            },
            newlyUnselectedStaffUserAccounts: {
                type: Array,
                default: null
            },
            initialCurrentSelectedStaffUserAccounts: {
                type: Array,
                default: null
            },
            defaultResponseTime: {
                type: Number,
                default: 6
            },
            allDefaultResponseTimeOptions: {
                type: Array,
                default: null
            },
            currentUserAccountId: {
                type: String,
                default: null
            },
            availableStaff: {
                type: Array,
                default: null
            },
            isDelayedAssignment: {
                type: Boolean,
                required: true
            },
            apiAssignmentControllerUrl: {
                type: String,
                required: true
            },
            rolesWithAudioMinutes: {
                type: Array,
                required: true
            },
            rolesWithRoundRobinPriority: {
                type: Array,
                required: true
            },
            turnAllocationMode: {
                type: Number,
                default: null
            }
        },
        data: function () {
            return {
                currentUserAccount: this.initialCurrentSelectedStaffUserAccounts.find(o => o.userAccountId === this.currentUserAccountId),
                // next line avoids this warning in the DRAGGABLE: Avoid mutating a prop directly since the value will be 
                // overwritten whenever the parent component re- renders.Instead, use a data or computed property based on the prop's value.
                currentSelectedStaffUserAccounts: this.initialCurrentSelectedStaffUserAccounts,
                comment: null,
                responseTime: this.defaultResponseTime,
                responseTimeOptions: this.allDefaultResponseTimeOptions,
                responseDueByDateTimeUTC: null,
                
                roleButtonsArray: [],
                showSpinner: false,
                showProtectedRoleAlert: false
            }
        },
        watch: {
            
        },
        computed: {

            //console.log('incoming prop turn allocation mode: ' + this.turnAllocationMode);
            //console.log('from enum: Round Robin value: ' + this.$enum.TurnAllocationMode.AssignedAudioLength);

            //FirstComeFirstServe = 0,
            //RoundRobin = 1,
            //AssignedAudioLength = 2

            roleSelectionIncomplete: function () {
                // check if every ADDED and EXISTING user has at least one role selected before submitting
                var flag = false;
                this.currentSelectedStaffUserAccounts.forEach(userAccount => {
                    if (userAccount.selectedRoles.length == 0) flag = true;
                });
                return flag;
            },

            nullMinuteAssignmentPresent: function () {
                var nullMinuteAssignmentPresent = false;
                if (this.turnAllocationMode == this.$enum.TurnAllocationMode.AssignedAudioLength) {
                    for (var i = 0; i < this.currentSelectedStaffUserAccounts.length; i++) {
                        var userAccount = this.currentSelectedStaffUserAccounts[i];
                        if (!(userAccount.userAccountId === this.currentUserAccountId)) {
                            if ((userAccount.audioMinutes == null || userAccount.audioMinutes == '') && this.userHasRolesWithAudioMinutes(userAccount.userAccountId)) nullMinuteAssignmentPresent = true;
                        }
                    }
                }
                return nullMinuteAssignmentPresent;
            },

            zeroMinuteAssignmentsPresent: function () {
                var zeroMinuteAssignments = false;
                for (var i = 0; i < this.currentSelectedStaffUserAccounts.length; i++)
                {
                    var userAccount = this.currentSelectedStaffUserAccounts[i];
                    if (!(userAccount.userAccountId === this.currentUserAccountId)) {
                        if (userAccount.audioMinutes == 0 && this.userHasRolesWithAudioMinutes(userAccount.userAccountId)) zeroMinuteAssignments = true;
                    }
                }
                return zeroMinuteAssignments;
            },

            getCurrentUserAccount: function () {
                return this.currentSelectedStaffUserAccounts.find(o => o.userAccountId === this.currentUserAccountId);
            },

            totalCurrentlyAssignedAudioMinutes: function () {
                var total = 0;
                // loop over all EXISTING (blue) and ADDED (green) users
                this.currentSelectedStaffUserAccounts.forEach(userAccount => { 
                    // find the user account in the newly added array
                    if (this.newlySelectedStaffUserAccounts == null) {
                        if (userAccount.audioMinutes != null) total += Number(userAccount.audioMinutes);
                    } else {
                    var userIndex = this.newlySelectedStaffUserAccounts.findIndex(e => e.userAccountId == userAccount.userAccountId);
                    // if the use is not newly added ... it must be EXISTING
                        if (userIndex == -1 &&  userAccount.audioMinutes != null) total += Number(userAccount.audioMinutes);
                    }
                });
                return total;
            },

            totalAddedAudioMinutes: function () {
                var total = 0;
                if (this.newlySelectedStaffUserAccounts == null) return 0;
                this.newlySelectedStaffUserAccounts.forEach(userAccount => {
                    if (userAccount.audioMinutes != null) total += Number(userAccount.audioMinutes);
                });
                return total;
            },

            totalRemovedAudioMinutes: function () {
                var total = 0;
                if (this.newlyUnselectedStaffUserAccounts == null) return 0;
                this.newlyUnselectedStaffUserAccounts.forEach(userAccount => {
                    if (userAccount.audioMinutes != null) total += Number(userAccount.audioMinutes);
                });
                return total;
            },

            newRemainingMinutesValue: function () {
                var remainingMinutes = this.totalAudioMinutes - this.totalCurrentlyAssignedAudioMinutes - this.totalAddedAudioMinutes + this.totalRemovedAudioMinutes;
                if (remainingMinutes < 0) remainingMinutes = 0;
                return remainingMinutes;
            }

        }, // computed

        methods:
        {
            removeUserFromAssignment: function (userAccountId) {
                var userAccountIndex = this.currentSelectedStaffUserAccounts.findIndex(e => e.userAccountId == userAccountId);
                if (userAccountIndex > -1)
                    this.currentSelectedStaffUserAccounts.splice(userAccountIndex, 1);
            },
            rowHovered: function (id) {
                if (this.roundRobinMode) {
                    var element = document.getElementById(id);
                    element.style.fontWeight = "bold";
                }
            },
            rowUnHovered: function (id) {
                if (this.roundRobinMode) {
                    var element = document.getElementById(id);
                    element.style.fontWeight = "normal";
                }
            },
            countValidCandidatesUpToIndex: function (index) {
                var nrOfStaff = 0;
                // here we are counting how many selected staff with an index smaller than
                // the current one have roles with a round robin priority ... once we found that count
                // that number is the next turn sequence, basically we skip the 'holes'
                for (var i = 0; i < index; i++) {
                    var staff = this.currentSelectedStaffUserAccounts[i];
                    if (staff.userAccountId !== this.currentUserAccountId) {

                        for (var j = 0; j < staff.selectedRoles.length; j++) {
                            var roleId = staff.selectedRoles[j];
                            if (this.rolesWithRoundRobinPriority.includes(roleId)) {
                                nrOfStaff++;
                                break;
                            }
                        }
                    }
                }
                return nrOfStaff + 1;
            },

            roundRobinPriority: function(index) {
                var currentUserIndex = this.currentSelectedStaffUserAccounts.findIndex(e => e.userAccountId == this.currentUserAccountId);
                // CASE 1: this is the current user, set roundRobinPriority = null;
                if (currentUserIndex >= 0 && index == currentUserIndex) return null; 
                var nrOfStaffWithValidRoles = this.countValidCandidatesUpToIndex(index);
                return nrOfStaffWithValidRoles;
            },

            validatePositiveInteger: function (event) {
                const keyCode = event.keyCode;
                // if key code is TAB do not prevent the default so user can navigate through form
                if (keyCode == 9) return true;
                if (!((keyCode >= 48 && keyCode <= 57) || (keyCode >= 96 && keyCode <= 105) || keyCode == 8)) {
                    event.preventDefault();
                }
            },

            // this method is triggered by the autofocus in the b-input
            highlightText: function () {
                const input = document.getElementById('firstAudioMinutesInput');
                // this marks/highlights the text
                input.select();
            },

            getStaffName: function (userAccountId) {
                var staff = this.availableStaff.find(e => e.userAccountId == userAccountId);
                if (staff) {
                    var fullName = staff.givenNames + ' ' + staff.lastName;
                    if (userAccountId === this.currentUserAccountId) fullName += ' (yourself)';
                    return fullName;
                }
                else { return 'You will be auto assigned to this worksheet!'; }
            },

            getRoleAbbreviation: function (roleDisplayName) {

                if (roleDisplayName === 'Quality Control') return 'QC';
                if (roleDisplayName === 'Monitoring Supervisor') return 'MS';
                if (roleDisplayName === 'Completer') return 'CP';

                return roleDisplayName.substring(0, 2).toUpperCase();
            },

            getRoles: function (userAccountId) {
                var staff = this.availableStaff.find(e => e.userAccountId == userAccountId);
                if (staff) return staff.roles
                else return [];
            },

            //userHasRolesWithAudioMinutes: function (userAccountId) {
            //    // get the users details
            //    var staff = this.availableStaff.find(e => e.userAccountId == userAccountId);
            //    var hasRolesWithAudioMinutes = false;
            //    if (staff) {
            //        // get the the array of role objects
            //        var rolesArray = staff.roles;
            //        // check if ANY of the user roles match any of the rolesWithAudioMinutes PROP
            //        rolesArray.forEach(role => {
            //            if (this.rolesWithAudioMinutes.includes(role.roleId)) {
            //                hasRolesWithAudioMinutes = true;
            //            }
            //        });
            //    }
            //    return hasRolesWithAudioMinutes;
            //},

            userHasRolesWithAudioMinutes: function (userAccountId) {
                // get the users details
                var staff = this.currentSelectedStaffUserAccounts.find(e => e.userAccountId == userAccountId);
                var hasRolesWithAudioMinutes = false;
                if (staff) {
                    // check if ANY of the users selected roles matches any of the rolesWithAudioMinutes PROP
                    staff.selectedRoles.forEach(roleId => {
                        if (this.rolesWithAudioMinutes.includes(roleId)) {
                            hasRolesWithAudioMinutes = true;
                        }
                    });
                } 
                return hasRolesWithAudioMinutes;
            },

            userHasRolesWithRoundRobinPriority: function (userAccountId) {
                // get the users details
                var staff = this.currentSelectedStaffUserAccounts.find(e => e.userAccountId == userAccountId);
                var hasRolesWithRoundRobinPriority = false;
                if (staff) {
                    // check if ANY of the users selected roles matches any of the rolesWithRoundRobinPriority PROP
                    staff.selectedRoles.forEach(roleId => {
                        if (this.rolesWithRoundRobinPriority.includes(roleId)) {
                            hasRolesWithRoundRobinPriority = true;
                        }
                    });
                }
                return hasRolesWithRoundRobinPriority;
            },

            selectRole: function (event, userAccountId, roleId) {

                var userAccount = this.currentSelectedStaffUserAccounts.find(e => e.userAccountId == userAccountId);
                this.showProtectedRoleAlert = false;
                
                // this indicates the user has not been selected before
                if (!('selectedRoles' in userAccount)) return;

                var roleIndex = userAccount.selectedRoles.indexOf(roleId);

                if (roleIndex != -1) {
                    if (!this.canUnselectRole(userAccount, roleId)) {
                        this.showProtectedRoleAlert = true;
                        return;
                    }
                    userAccount.selectedRoles.splice(roleIndex,1);
                    event.target.classList.remove('bg-success');
                    // check if a user does not have any roles with round robin priority left ...
                    // if so ... additionally to the :disabled prop we also set the audio minutes for this user to null;
                    if (!this.userHasRolesWithRoundRobinPriority(userAccountId)) userAccount.audioMinutes = null;
                } else {
                    userAccount.selectedRoles.push(roleId);
                    event.target.classList.add('bg-success');
                }
            },

            canUnselectRole: function (userAccount, roleId) {
                if (userAccount.requiredRoles) {
                    var newSelectedRoles = [];
                    userAccount.selectedRoles.forEach(r => {
                        if (r != roleId) {
                            newSelectedRoles.push(r);
                        }
                    });
                    //requiredRoles is actually and array of arrays - this is how it works
                    //each of the arrays that are included in the requiredRoles array dedicate a list of roles where the user has to have at least one of those roles
                    //e.g. if the user is assigned to a turn to type, then he has to have at least one of the following roles - Transcriber, Steno, Editor
                    var canUnselectRole = true;
                    userAccount.requiredRoles.forEach(subRequiredRoles => {
                        if (subRequiredRoles.findIndex(r => newSelectedRoles.includes(r)) < 0) {
                            canUnselectRole = false;
                        }
                    });
                    return canUnselectRole;
                }
                return true;
            },
                        
            assignSelectedStaff: function () {

                // Dont proceed if not every user has at least one role selected
                if (this.roleSelectionIncomplete) return;
                if (this.nullMinuteAssignmentPresent) return;
                if (this.zeroMinuteAssignmentsPresent) return;

                this.showSpinner = true;
                var url = this.apiAssignmentControllerUrl;

                if (!url.endsWith('/')) url += '/';
                url += 'usersbyworkitem/';
                url += this.workItemId;

                if (this.roundRobinMode) {
                    for (var i = 0; i < this.currentSelectedStaffUserAccounts.length; i++) {
                        this.currentSelectedStaffUserAccounts[i].roundRobinPriority = this.roundRobinPriority(i);
                    }
                }

                var data = {
                    users: this.currentSelectedStaffUserAccounts,
                    comment: this.comment,
                    expiryTimeInHours: this.responseTime
                };

                this.currentErrors = [];
                axios
                    .post(url, JSON.stringify(data),
                        {
                            headers: {
                                'Content-Type': 'application/json'
                            }
                        })
                    .then(() => {
                        this.showSpinner = false;
                        this.comment = '';
                        this.responseTime = 6;
                        this.$emit('assignmentChanged');
                    })
                    .catch(ex => {
                        
                        this.showSpinner = false;
                        this.currentError = this.handleAxiosException(ex);
                        
                        this.showErrorsToast(this.currentError);
                    })
                    .finally(() => {
                        if (this.currentErrors.length == 0) {
                            this.staffWorkItemAssignmentEditDialogOpen = false;
                        }
                    })
            }
        },

        mounted: function () {
                
        }
    }
</script>

<style scoped>
    
</style>
